import styled from "@emotion/styled";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button as AIMEButton } from "tot-loft-component-library";
import { HamburgerIcon, PaartnerLogo } from "../assets";
import { ProfileDropdown } from "../prtnr";
import { logout } from "../redux/slices/authSlice";
import { checkAuthStatus, logoutUser } from "../redux/slices/authThunks";
import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { scrollToTop } from "../utils";

function Navbar(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const vendor = JSON.parse(localStorage.getItem("vendor"));
  const user = JSON.parse(localStorage.getItem("user"));

  const handleLogout = async () => {
    try {
      await dispatch(logoutUser()).unwrap();
      dispatch(logout());
      window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
    } catch (e) {
      console.error("Logout error:", e);
    } finally {
      // Always run this, success or failure
      dispatch(checkAuthStatus());
    }
  };
  const menuItems = [
    {
      label: "Profile Settings",
      onClick: () => {
        navigate("/profileinfoone");
        setIsMobileMenuOpen(false);
      },
    },
    {
      label: "Help",
      onClick: () => {
        navigate("/help");
        setIsMobileMenuOpen(false);
      },
    },
    {
      label: "Signout",
      onClick: () => {
        handleLogout();
      },
    },
  ];
  const isStaging = process.env.REACT_APP_ENV === "staging";
  return (
    <Header>
      <HeaderWrapper>
        <Left>
          <LogoHamburgerWrapper>
            <div
              style={{
                display: "flex",
                alignItems: "center",   
                gap: "12px",   
                width: "fit-content"        
              }}
            >
              <Logo
                onClick={() => {
                  navigate("/");
                  setIsMobileMenuOpen(false);
                  scrollToTop();
                }}
                src={PaartnerLogo}
                alt="Paartner Logo"
              />
              {isStaging && (
                <>
                  <div
                    style={{
                      color: "red",
                      padding: "10px",
                      textAlign: "center",
                      fontWeight: "bold",
                      zIndex: 9999,
                    }}
                  >
                    🔴 STAGING
                  </div>
                </>
              )}
            </div>
            <AnimatePresence mode="wait">
              <Hamburger
                key={isMobileMenuOpen ? "close" : "open"}
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                as={motion.div}
                initial={{ opacity: 0, rotate: -10, scale: 0.9 }}
                animate={{ opacity: 1, rotate: 0, scale: 1 }}
                exit={{ opacity: 0, rotate: 10, scale: 0.9 }}
                transition={{ duration: 0.2 }}
              >
                {isMobileMenuOpen ? (
                  <CloseIcon>&times;</CloseIcon>
                ) : (
                  <>
                    <img src={HamburgerIcon} alt="Bars" />
                  </>
                )}
              </Hamburger>
            </AnimatePresence>
          </LogoHamburgerWrapper>
        </Left>
        <Middle isOpen={isMobileMenuOpen}>
          <NavLinks>
            <AIMEButton
              size="small"
              onClick={() => {
                navigate("/");
                setIsMobileMenuOpen(false);
                scrollToTop();
              }}
              sx={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "row",
                alignItems: "center",
                flex: "none",
                gap: "10px",
                background: "rgb(255, 255, 255)",
                backgroundRepeat: "no-repeat",
                backgroundSize: "contain",
                backgroundPosition: "center",
                boxSizing: "border-box",
                padding: "8px",
              }}
            >
              <span
                style={{
                  color: "rgb(33, 37, 67)",
                  textOverflow: "ellipsis",
                  fontSize: "16px",
                  fontFamily: "Montserrat, sans-serif",
                  fontWeight: "500",
                  lineHeight: "22px",
                  textAlign: "left",
                }}
              >
                Dashboard
              </span>
            </AIMEButton>
            <AIMEButton
              size="small"
              onClick={() => {
                navigate("/referrals");
                setIsMobileMenuOpen(false);
                scrollToTop();
              }}
              sx={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "row",
                alignItems: "center",
                flex: "none",
                gap: "10px",
                background: "rgb(255, 255, 255)",
                backgroundRepeat: "no-repeat",
                backgroundSize: "contain",
                backgroundPosition: "center",
                boxSizing: "border-box",
                padding: "8px",
              }}
            >
              <span
                style={{
                  color: "rgb(33, 37, 67)",
                  textOverflow: "ellipsis",
                  fontSize: "16px",
                  fontFamily: "Montserrat, sans-serif",
                  fontWeight: "500",
                  lineHeight: "22px",
                  textAlign: "left",
                }}
              >
                Referrals
              </span>
            </AIMEButton>

            <AIMEButton
              size="small"
              onClick={() => {
                navigate("/profileone");
                setIsMobileMenuOpen(false);
                scrollToTop();
              }}
              sx={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "row",
                alignItems: "center",
                flex: "none",
                gap: "10px",
                background: "rgb(255, 255, 255)",
                backgroundRepeat: "no-repeat",
                backgroundSize: "contain",
                backgroundPosition: "center",
                boxSizing: "border-box",
                padding: "8px",
              }}
            >
              <span
                style={{
                  color: "rgb(33, 37, 67)",
                  textOverflow: "ellipsis",
                  fontSize: "16px",
                  fontFamily: "Montserrat, sans-serif",
                  fontWeight: "500",
                  lineHeight: "22px",
                  textAlign: "left",
                }}
              >
                Vendor Profile
              </span>
            </AIMEButton>
          </NavLinks>
        </Middle>
        <NavUser isOpen={isMobileMenuOpen}>
          <ProfileDropdown
            menuItems={menuItems}
            name={vendor?.company_name}
            imageUrl={user?.profile_picture}
          />
        </NavUser>
      </HeaderWrapper>
    </Header>
  );
}

export default Navbar;

const Header = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 9999;
  @media (max-width: 767px) {
    padding: 0;
    margin-bottom: 78px;
  }
`;

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  flex: 1;
  border-radius: 12px;
  width: 1200px;
  background: linear-gradient(
    -90deg,
    rgba(255, 255, 255, 0.85),
    rgba(255, 255, 255, 0.85)
  );
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px 16px;
  backdrop-filter: blur(10px);
  z-index: 999;
  @media (max-width: 767px) {
    flex-direction: column;
    align-items: flex-start;
    border-radius: 0px;
    flex: 1;
  }
`;

const Left = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
  @media (max-width: 767px) {
    width: 100%;
    flex: 1;
  }
`;

const Logo = styled.img`
  width: 165px;
  height: 24px;
  position: relative;
`;

const Middle = styled.div`
  /* display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  flex: 1;
  gap: 8px;
  width: 868px;
  box-sizing: border-box; */
  display: flex;
  justify-content: center;
  flex: 1;
  transition: max-height 0.4s ease, opacity 0.4s ease;

  @media (max-width: 767px) {
    flex-direction: column;
    width: 100%;
    display: ${({ isOpen }) => (isOpen ? "flex" : "none")};
    margin-top: 32px;
    max-height: ${({ isOpen }) =>
    isOpen ? "1000px" : "0"}; /* large enough max */
    opacity: ${({ isOpen }) => (isOpen ? "1" : "0")};
  }
`;

const NavLinks = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
  @media (max-width: 767px) {
    flex-direction: column;
    width: 100%;
  }
`;

const ButtonsApp = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 10px;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 8px;
`;

const ButtonLabel = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 22px;
  text-align: left;
`;

const PrtnrDropdown = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const Button = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 8px;
  border-radius: 999px;
  background: rgb(226, 232, 240);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding-bottom: 4px;
  padding-top: 4px;
  padding-left: 4px;
  padding-right: 16px;
`;

const Image = styled.div`
  width: 40px;
  height: 40px;
  position: relative;
`;

const Image_0001 = styled.div`
  background: url(https://s3-alpha-sig.figma.com/img/26eb/10bc/0215ce531a4897da371d515ad69851ad?Expires=1749427200&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=M15H208j5Zl6hRPEvKa8bRve2s9du3SyHXyfkQVN0ystDE~6S0JNaDN6aUE-ARfeO1ytqt2TCnmVzc2y5Ex~Mkc7QJTYU9xktbDPCv30Fw2TAqrgE-AcD2iQR3vgirQ9OJ8D-ijCiHsWNdcLYPsxYcqtMfaP3hFl4t0AGzXcR1sdtUlsU2gau~HiVSEnIKJxp44yDSYZirpTYsXTMrfq3kv9cF2ny~75z9M4AqrkNdK9MoPmo-0~8ebloTDVppSpKJDX9fIXI9nGy4CEWXV2OR~wIAqiJQ84-wQHcyDJEFLOTClmRtfGZmYme4ZaIdju6ZajYTrK-~FuIXh7sOkhlw__);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  border-radius: 40px / 40px;
  position: absolute;
  left: 0px;
  top: 0px;
  right: 0px;
  bottom: 0px;
`;

const JamesD = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  line-height: 110%;
  text-align: left;
`;

const ChevronUp = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: "Font Awesome 6 Pro", sans-serif;
  font-weight: 400;
  text-align: left;
`;

const Dashboard = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  background: rgb(241, 245, 249);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 0px 60px;
  flex-shrink: 0;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: none;
  width: 1200px;
  box-sizing: border-box;
  padding: 0px 0px 32px;
`;

const DashboardHeader = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  padding: 32px 0px;
  flex-shrink: 0;
`;

const Frame1462 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 4px;
  width: 1010px;
  box-sizing: border-box;
`;

const WelcomeJames = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 48px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  letter-spacing: -1px;
  text-align: center;
`;

const Frame1461 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const ButtonsApp_0003 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 10px;
  border-radius: 48px;
  background: rgb(33, 37, 67);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 16px 32px;
`;

const ButtonLabel_0003 = styled.span`
  color: white;
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  line-height: 110%;
  text-align: left;
`;
const NavUser = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  @media (max-width: 767px) {
    width: 100%;
    justify-content: flex-start;
    margin-top: 16px;
    display: ${({ isOpen }) => (isOpen ? "flex" : "none")};
    flex-direction: column;
  }
`;

const Hamburger = styled.div`
  display: none;
  cursor: pointer;
  height: 24px;

  @media (max-width: 767px) {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 8px;
  }
`;
const LogoHamburgerWrapper = styled.div`
  width: 100%;
  justify-content: flex-start;

  @media (max-width: 767px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    flex: 1;
  }
`;
const CloseIcon = styled.span`
  font-size: 28px;
  line-height: 28px;
  color: #64748b;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 18px;
  height: 24px;
`;
